import { useEffect } from "react";

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export default function useSeo(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | The Ananta Hotels` : "The Ananta Hotels";
    if (description) setMeta("description", description);
    window.scrollTo(0, 0);
  }, [title, description]);
}
